import { useCallback } from 'react';
import { SelectRxDialog } from '../SelectRxDialog.jsx';
import { useContext } from '../../context.jsx';
import { usePdfContext } from './pdf-context.jsx';

export function PdfDialog() {
  const { tab } = useContext();
  const { isFiltering, setFiltering, setFilters } = usePdfContext();

  const onCancel = useCallback(() => {
    setFiltering(false);
    setFilters([]);
  }, [setFiltering, setFilters]);

  const onSave = useCallback(
    (selection) => {
      setFiltering(false);
      setFilters(selection);
    },
    [setFiltering, setFilters],
  );

  return isFiltering ? (
    <SelectRxDialog
      title="Print to PDF"
      selectedOption={tab}
      saveSelection={onSave}
      cancelSelection={onCancel}
    />
  ) : null;
}
